var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 65,
    viewBox: "0 0 70 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.7817 63.4687C68.5485 63.8584 68.213 64.1819 67.809 64.4068C67.405 64.6317 66.9467 64.7501 66.4802 64.75H2.7153C2.24916 64.7495 1.79134 64.6308 1.38782 64.4057C0.984307 64.1806 0.649296 63.8571 0.416429 63.4676C0.183563 63.0781 0.0610376 62.6364 0.0611573 62.1868C0.061277 61.7372 0.184037 61.2956 0.417111 60.9062C5.47513 52.4724 13.2697 46.4249 22.3662 43.5581C17.8667 40.9746 14.3708 37.0381 12.4155 32.3529C10.4602 27.6678 10.1535 22.4931 11.5426 17.6235C12.9316 12.754 15.9396 8.45889 20.1046 5.39776C24.2696 2.33663 29.3613 0.678772 34.5977 0.678772C39.8342 0.678772 44.9259 2.33663 49.0909 5.39776C53.2559 8.45889 56.2639 12.754 57.6529 17.6235C59.042 22.4931 58.7353 27.6678 56.78 32.3529C54.8247 37.0381 51.3288 40.9746 46.8293 43.5581C55.9258 46.4249 63.7204 52.4724 68.7784 60.9062C69.0121 61.2955 69.1354 61.7372 69.136 62.187C69.1366 62.6369 69.0144 63.0789 68.7817 63.4687Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.26514f9e0415a384133bbeb2c497732c.svg";
export { ForwardRef as ReactComponent };